import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CollectorEligibilityContext } from '../../domain/user';

export interface TaskExchangeDialogData {
  currentCollectorAuthId: string | null;
  eligibilityContext: CollectorEligibilityContext;
}

@Component({
  selector: 'app-task-exchange-dialog',
  templateUrl: './task-exchange-dialog.component.html',
  styleUrls: ['./task-exchange-dialog.component.css']
})
export class TaskExchangeDialogComponent {
  collectorAuth0Id = '';
  errorMessage = '';

  constructor(
    private dialogRef: MatDialogRef<TaskExchangeDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) public data: TaskExchangeDialogData
  ) {}

  onCollectorChanged(auth0Id: string): void {
    this.collectorAuth0Id = auth0Id?.trim() ?? '';
    this.errorMessage = '';
  }

  apply(): void {
    const normalizedCollectorAuth0Id = this.collectorAuth0Id?.trim();
    if (!normalizedCollectorAuth0Id) {
      return;
    }

    if (normalizedCollectorAuth0Id === this.data?.currentCollectorAuthId) {
      this.errorMessage = 'Please select a different collector.';
      return;
    }

    this.dialogRef.close(normalizedCollectorAuth0Id);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
